import * as React from 'react';
import FeatureUpdateNoticeFormContainer from 'containers/notice/FeatureUpdateNoticeFormContainer';

const FeatureUpdateNoticeForm = () => {
  return <FeatureUpdateNoticeFormContainer />;
};

export default FeatureUpdateNoticeForm;
